import React from 'react';
import { BilingualText } from './BilingualText';
interface CapacityCardProps {
  labelEn: string;
  labelAr: string;
  current: number;
  total: number;
  unitEn: string;
  unitAr: string;
}
export function CapacityCard({
  labelEn,
  labelAr,
  current,
  total,
  unitEn,
  unitAr
}: CapacityCardProps) {
  const percentage = Math.round(current / total * 100);
  const getColorClass = (pct: number) => {
    if (pct >= 90) return 'bg-red-500';
    if (pct >= 70) return 'bg-yellow-500';
    return 'bg-green-500';
  };
  const getTextColorClass = (pct: number) => {
    if (pct >= 90) return 'text-red-600';
    if (pct >= 70) return 'text-yellow-600';
    return 'text-green-600';
  };
  return <div className="card p-4 space-y-4" data-id="element-57">
      <div className="flex justify-between items-start" data-id="element-58">
        <BilingualText en={labelEn} ar={labelAr} data-id="element-59" />
        <div className={`text-right ${getTextColorClass(percentage)}`} data-id="element-60">
          <div className="text-2xl font-bold" data-id="element-61">{percentage}%</div>
        </div>
      </div>

      <div className="w-full bg-slate-100 rounded-full h-3 overflow-hidden" data-id="element-62">
        <div className={`h-full transition-all duration-500 ${getColorClass(percentage)}`} style={{
        width: `${Math.min(percentage, 100)}%`
      }} data-id="element-63" />
      </div>

      <div className="flex justify-between text-sm" data-id="element-64">
        <div className="flex flex-col" data-id="element-65">
          <span className="text-slate-500 font-medium" data-id="element-66">
            {current} / {total}
          </span>
          <span className="text-slate-400 text-xs font-arabic" dir="rtl" data-id="element-67">
            {unitAr}
          </span>
        </div>
        <BilingualText en={`${total - current} remaining`} ar={`المتبقي ${total - current}`} subtle reverse data-id="element-68" />
      </div>
    </div>;
}